import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '~/api-client';
import type {
    UsageActionEnumType,
    UsageCompletionEnumType,
    UsageSourceModuleEnumType,
    EntityTypeEnumType,
} from '@mark43/cad-api';
import { UsageSourceApplicationEnum } from '@mark43/cad-api';

export interface UsageLogCreationRequest {
    action: UsageActionEnumType;
    completion: UsageCompletionEnumType;
    sourceModule: UsageSourceModuleEnumType;
    primaryEntityType: EntityTypeEnumType;
    primaryEntityTitle: string;
    primaryEntityId: number;
}

type CreateUsageLog = {
    path: 'usage_logs';
    method: 'POST';
    data: UsageLogCreationRequest & { sourceApplication: string; usageLogDateUtc: string };
    returns: void;
};

export function useUsageLog() {
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async function sendUsageLog(payload: UsageLogCreationRequest) {
            const sourceApplication =
                process.env.APP_NAME === 'first-responder'
                    ? UsageSourceApplicationEnum.FIRST_RESPONDER.name
                    : UsageSourceApplicationEnum.CAD.name;

            await apiClient.request<CreateUsageLog>({
                method: 'POST',
                url: 'usage_logs',
                service: 'USAGE_LOGS',
                data: {
                    ...payload,
                    sourceApplication,
                    usageLogDateUtc: new Date().toISOString(),
                },
                shouldFailSilently: true,
            });
        },
    });
}
